import React, { useMemo } from "react";
import {
  FaBullhorn,
  FaDesktop,
  FaLayerGroup,
  FaQrcode,
  FaSyncAlt,
} from "react-icons/fa";

const isValidUrl = (value = "") => {
  try {
    const url = new URL(String(value).trim());

    return ["http:", "https:"].includes(
      url.protocol
    );
  } catch {
    return false;
  }
};

export default function CastingHeader({
  event,
  eventId,
  panel,
  setPanel,
  castState,
  onRefresh,
  onOpenScreen,
  onSetMode,
}) {
  const screenMode =
    castState?.mode || "MATS";

  const hasActiveMessage = Boolean(
    castState?.active_message_id
  );

  const hasFollowQr = useMemo(
    () => isValidUrl(event?.suivi_event),
    [event?.suivi_event]
  );

  return (
    <header className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-[0_20px_60px_rgba(15,23,42,0.08)] dark:border-white/10 dark:bg-slate-900">
      <div className="bg-gradient-to-br from-sky-700 via-blue-700 to-indigo-800 px-5 py-6 text-white sm:px-7">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <p className="text-xs font-black uppercase tracking-[0.25em] text-sky-100">
              Affichage compétition
            </p>

            <h1 className="mt-2 text-2xl font-black sm:text-3xl">
              {event?.titre ||
                "Gestion des surfaces"}
            </h1>

            <div className="mt-3 flex flex-wrap items-center gap-2 text-xs font-bold text-white/80">
              <span>Événement #{eventId}</span>

              {hasFollowQr ? (
                <span className="inline-flex items-center gap-1.5 rounded-full bg-white/15 px-3 py-1">
                  <FaQrcode />
                  QR de suivi disponible
                </span>
              ) : null}

              <span className="rounded-full bg-white/15 px-3 py-1">
                Écran :{" "}
                {screenMode === "MATS"
                  ? "Surfaces"
                  : "Message"}
              </span>
            </div>
          </div>

          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={onRefresh}
              className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-white/15 px-4 text-sm font-black text-white transition hover:bg-white/25"
            >
              <FaSyncAlt />
              Actualiser
            </button>

            <button
              type="button"
              onClick={onOpenScreen}
              className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-white px-4 text-sm font-black text-blue-700 transition hover:bg-sky-50"
            >
              <FaDesktop />
              Ouvrir l’écran dojo
            </button>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-4 px-4 py-4 sm:px-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => setPanel("mats")}
            className={[
              "inline-flex min-h-10 items-center gap-2 rounded-xl px-4 text-sm font-black transition",
              panel === "mats"
                ? "bg-sky-600 text-white"
                : "bg-slate-100 text-slate-700 hover:bg-slate-200 dark:bg-white/10 dark:text-white dark:hover:bg-white/15",
            ].join(" ")}
          >
            <FaLayerGroup />
            Surfaces
          </button>

          <button
            type="button"
            onClick={() =>
              setPanel("messages")
            }
            className={[
              "inline-flex min-h-10 items-center gap-2 rounded-xl px-4 text-sm font-black transition",
              panel === "messages"
                ? "bg-sky-600 text-white"
                : "bg-slate-100 text-slate-700 hover:bg-slate-200 dark:bg-white/10 dark:text-white dark:hover:bg-white/15",
            ].join(" ")}
          >
            <FaBullhorn />
            Messages
          </button>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <span className="mr-1 text-xs font-black uppercase tracking-wider text-slate-500 dark:text-slate-400">
            Diffusion écran
          </span>

          <button
            type="button"
            onClick={() => onSetMode("MATS")}
            className={[
              "min-h-9 rounded-xl px-3 text-xs font-black transition",
              screenMode === "MATS"
                ? "bg-emerald-600 text-white"
                : "bg-slate-100 text-slate-700 dark:bg-white/10 dark:text-white",
            ].join(" ")}
          >
            Afficher les surfaces
          </button>

          <button
            type="button"
            onClick={() =>
              onSetMode("MESSAGE")
            }
            disabled={!hasActiveMessage}
            className={[
              "min-h-9 rounded-xl px-3 text-xs font-black transition disabled:cursor-not-allowed disabled:opacity-40",
              screenMode === "MESSAGE"
                ? "bg-amber-500 text-slate-950"
                : "bg-slate-100 text-slate-700 dark:bg-white/10 dark:text-white",
            ].join(" ")}
            title={
              hasActiveMessage
                ? "Afficher le message actif"
                : "Aucun message n’est actuellement diffusé"
            }
          >
            Afficher le message
          </button>
        </div>
      </div>
    </header>
  );
}